<template>
    <rkm-data-table
        :fields="fields.datatables.kitExame"
        :repository="repositories.kitExame"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'parametrizacao-kit-exame-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-parametrizacao-kit-exame"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-parametrizacao-kit-exame"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    kitExame: [
                        {
                            name: 'parametrizacaoKitExame.nome',
                            key: 'nome',
                            label: 'Nome do kit',
                            searchable: true,
                            sortable: true
                        },
                        {
                            name: 'parametrizacaoKitExameTipo.nome',
                            key: 'tipo',
                            label: 'Tipo de exame',
                            searchable: true,
                            sortable: true
                        },
                        {
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            kitExame: this.getConectaSusRepository('parametrizacao.kitExame')
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.kitExame.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o kit de exame?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
}
</script>